import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { prefix } from '../../tools/settings';
import SegmentedControl from '../SegmentedControl';
import SearchInput from '../SearchInput';
import Icon from '../Icon';
var ListSegmentedControl = styled(SegmentedControl).withConfig({
  displayName: "Liststyles__ListSegmentedControl",
  componentId: "sc-1qiobra-0"
})([""]);
var List = styled.div.withConfig({
  displayName: "Liststyles__List",
  componentId: "sc-1qiobra-1"
})(["display:flex;flex-flow:column nowrap;flex:1 1 auto;"]);
var ListSelectArrow = styled(Icon).withConfig({
  displayName: "Liststyles__ListSelectArrow",
  componentId: "sc-1qiobra-2"
})(["color:var(--dentsu-color-blue);position:absolute;right:10px;top:50%;pointer-events:none;transform:translateY(-50%);"]);
var ListSearch = styled(SearchInput).withConfig({
  displayName: "Liststyles__ListSearch",
  componentId: "sc-1qiobra-3"
})(["width:auto;.bp3-input{width:120px;transition:width var(--dentsu-motion-duration-fast) var(--dentsu-motion-easing-standard);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;&:focus,&:not(:placeholder-shown){width:210px;text-overflow:initial;}}"]);
var ListHead = styled.div.attrs({
  className: 'dentsu-list__head'
}).withConfig({
  displayName: "Liststyles__ListHead",
  componentId: "sc-1qiobra-4"
})(["width:100%;display:flex;justify-content:space-between;align-items:center;height:68px;font-size:14px;color:var(--dentsu-color-n700);padding:0 24px;top:0;background:inherit;z-index:1;border-bottom:1px solid var(--dentsu-color-n300);.filtered{padding-left:4px;}.", "-list--hideSearch.", "-list--hideTotal &{display:none;}"], prefix, prefix);
var ListHeadCell = styled.div.withConfig({
  displayName: "Liststyles__ListHeadCell",
  componentId: "sc-1qiobra-5"
})(["display:flex;flex-flow:row nowrap;", ""], function (props) {
  return props.right && css(["> *{margin-left:12px;}> .", "-segmented-control{margin-left:6px;}"], prefix);
});
var ListControl = styled.span.withConfig({
  displayName: "Liststyles__ListControl",
  componentId: "sc-1qiobra-6"
})(["position:relative;margin:0 0 0 8px;"]);
var ListSelectLabel = styled.label.withConfig({
  displayName: "Liststyles__ListSelectLabel",
  componentId: "sc-1qiobra-7"
})(["color:var(--dentsu-color-n600);padding-right:8px;&:after{content:':';}"]);
var ListFilter = styled.div.withConfig({
  displayName: "Liststyles__ListFilter",
  componentId: "sc-1qiobra-8"
})(["display:flex;width:auto;align-items:center;border-radius:18px;border:1px solid var(--dentsu-color-n300);height:36px;padding:0 0 0 16px;background-color:var(--dentsu-color-white);"]);
var ListSelect = styled.select.withConfig({
  displayName: "Liststyles__ListSelect",
  componentId: "sc-1qiobra-9"
})(["display:inline-block;width:auto;height:36px;appearance:none;background:transparent;border:none;padding-right:32px;font-weight:var(--dentsu-font-weight-medium);&:focus{outline:none;}&:after{content:'';display:block;position:absolute;right:0;top:0;width:14px;height:14px;border-left:2px solid var(--dentsu-color-blue);border-bottom:2px solid var(--dentsu-color-blue);transform:rotate(45deg);}"]);
var ListBody = styled.div.withConfig({
  displayName: "Liststyles__ListBody",
  componentId: "sc-1qiobra-10"
})(["width:100%;position:relative;z-index:0;.", "-card-group{margin-left:-16px;margin-right:-16px;}"], prefix);
var ListRow = styled.div.withConfig({
  displayName: "Liststyles__ListRow",
  componentId: "sc-1qiobra-11"
})(["display:flex;width:100%;padding:0 12px;flex-flow:row nowrap;background:var(--dentsu-color-white);border-bottom:1px solid var(--dentsu-color-n300);", ""], function (props) {
  return props.onClick && css(["cursor:pointer;box-shadow:none;transition:box-shadow var(--dentsu-motion-duration-fast) var(--dentsu-motion-easing-standard);&:hover{box-shadow:var(--dentsu-shadow-2);}&:active{box-shadow:none;}"]);
});
var ListCell = styled.div.withConfig({
  displayName: "Liststyles__ListCell",
  componentId: "sc-1qiobra-12"
})(["display:flex;flex-flow:column nowrap;flex-grow:1;flex-basis:0;position:relative;justify-content:center;line-height:1;padding:16px 12px;", " ", " ", ""], function (props) {
  return props.image && css(["max-width:64px;"]);
}, function (props) {
  return props.title && css(["padding-right:20px;"]);
}, function (props) {
  return props.actions && css(["justify-content:flex-end;flex-flow:row nowrap;align-items:center;flex-grow:0;flex-shrink:1;> *{margin-left:8px;}"]);
});
var ListTitle = styled.h3.withConfig({
  displayName: "Liststyles__ListTitle",
  componentId: "sc-1qiobra-13"
})(["color:var(--dentsu-color-black);font-weight:var(--dentsu-font-weight-medium);font-size:var(--dentsu-font-size-14);line-height:", ";max-width:360px;"], rem(20));
var ListCaption = styled.p.withConfig({
  displayName: "Liststyles__ListCaption",
  componentId: "sc-1qiobra-14"
})(["color:var(--dentsu-color-n700);font-weight:var(--dentsu-font-weight-regular);font-size:var(--dentsu-font-size-14);line-height:", ";max-width:360px;"], rem(20));
var ListImage = styled.div.withConfig({
  displayName: "Liststyles__ListImage",
  componentId: "sc-1qiobra-15"
})([""]);
var ListPagination = styled.div.withConfig({
  displayName: "Liststyles__ListPagination",
  componentId: "sc-1qiobra-16"
})(["height:68px;display:flex;justify-content:space-between;align-items:center;font-size:14px;color:var(--dentsu-color-n700);padding:16px 16px;"]);
var ListPaginationSelection = styled.span.withConfig({
  displayName: "Liststyles__ListPaginationSelection",
  componentId: "sc-1qiobra-17"
})(["&::first-letter{text-transform:capitalize;}"]);
var ListPaginationOptions = styled.div.withConfig({
  displayName: "Liststyles__ListPaginationOptions",
  componentId: "sc-1qiobra-18"
})([""]);
var ListPaginationNavigation = styled.div.withConfig({
  displayName: "Liststyles__ListPaginationNavigation",
  componentId: "sc-1qiobra-19"
})([""]);
var ListPaginationButtons = styled.span.withConfig({
  displayName: "Liststyles__ListPaginationButtons",
  componentId: "sc-1qiobra-20"
})(["border-left:1px solid var(--dentsu-color-n300);margin-left:16px;padding-left:8px;"]);
var ListAction = styled.div.withConfig({
  displayName: "Liststyles__ListAction",
  componentId: "sc-1qiobra-21"
})([".dentsu-button{height:36px;padding-top:11px;padding-bottom:11px;padding-left:20px;padding-right:20px;}"]);
export var Styled = {
  List: List,
  ListHead: ListHead,
  ListHeadCell: ListHeadCell,
  ListBody: ListBody,
  ListRow: ListRow,
  ListCell: ListCell,
  ListAction: ListAction,
  ListImage: ListImage,
  ListTitle: ListTitle,
  ListCaption: ListCaption,
  ListSegmentedControl: ListSegmentedControl,
  ListSearch: ListSearch,
  ListSelect: ListSelect,
  ListSelectArrow: ListSelectArrow,
  ListSelectLabel: ListSelectLabel,
  ListControl: ListControl,
  ListFilter: ListFilter,
  ListPagination: ListPagination,
  ListPaginationSelection: ListPaginationSelection,
  ListPaginationNavigation: ListPaginationNavigation,
  ListPaginationOptions: ListPaginationOptions,
  ListPaginationButtons: ListPaginationButtons
};